export default 'dashboardApp';
